<template>
    <div class="full-width" id="notification-header"> 
    </div>
</template>

<style scoped>
#notification-header{
    height: 10px;
}
</style>